import cn from 'classnames';
import dynamic from 'next/dynamic';
import SectionTitle from 'UI/components/SectionTitle';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import ContentfulParser from 'components/BlogCommon/Article/ContentfulParser';
import AccordionItem from 'UI/components/AccordionItem';
import Svg from 'UI/components/Svg';
import useSectionProps from './utils/useSectionProps';
import styles from './styles.module.scss';

const Media = dynamic(() => import('UI/components/Media'));

const CaseAccordion = (props) => {
  const {
    title,
    description,
    accordionList,
    activeAccordion,
    handleAccordionClick,
    activeImage,
    view,
    type,
  } = useSectionProps(props);

  return (
    <section className={cn(styles[view], styles[type], styles.section)}>
      <SectionTitle
        title={title}
        description={description}
        className={styles.sectionTitle}
      />

      <div className={styles.contentWrapper}>
        <ul className={styles.accordion}>
          {(accordionList || []).map((item, id) => (
            <AccordionItem
              key={id}
              isOpen={id === activeAccordion}
              handleClick={() => handleAccordionClick(id)}
              title={item.title}
              className={styles.accordionItem}
              isCloseClassName={styles.isClose}
              isOpenClassName={styles.isOpen}
            >
              <ContentfulParser
                document={item.text}
                linkIcon={<Svg type="arrowNarrowUp" />}
              />
            </AccordionItem>
          ))}
        </ul>
        <SwitchTransition>
          <CSSTransition
            key={title}
            timeout={300}
            classNames={{
              enter: styles['fade-enter'],
              enterActive: styles['fade-enter-active'],
              exit: styles['fade-exit'],
              exitActive: styles['fade-exit-active'],
            }}
          >
            <div className={styles['card-body']}>
              {activeImage && (
                <Media
                  asset={activeImage}
                  className={styles.media}
                />
              )}
            </div>
          </CSSTransition>
        </SwitchTransition>
      </div>
    </section>
  );
};

export default CaseAccordion;
